import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { homepageWins } from "../../data/caseResults";
import { resultsDisclaimer } from "../../data/site";
import { SiteLink } from "../SiteLink";
export function MoreWins() {
  return <section aria-labelledby="more-wins-title" className="border-b border-line bg-ivory" data-id="element-240" data-mp="2i0banue3bexm">
      <div className="page-container py-14 md:py-20" data-id="element-241" data-mp="2d31dfskglyz8">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between lg:gap-10" data-id="element-242" data-mp="1pbvuh4j82qkp">
          <div className="max-w-measure" data-id="element-243" data-mp="1latuglhheaho">
            <p className="eyebrow text-label font-bold text-crimson" data-id="element-244" data-mp="1lc4xuk70lg89">Results for Michigan riders</p>
            <h2 id="more-wins-title" className="section-title mt-3 text-h2-m font-extrabold text-ink md:text-h2" data-id="element-245" data-mp="1zbwjn73rw0wt">
              More cases. Real outcomes.
            </h2>
          </div>
          <SiteLink path="/cases/" className="inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-ink underline underline-offset-4" data-id="element-246" data-mp="3ao72olspsio2">
            View all cases
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-247" data-mp="1s3l7aowu5lrj" />
          </SiteLink>
        </div>

        <p className="mt-5 max-w-measure text-body-m text-slate md:text-body" data-id="element-248" data-mp="1x0v5ou27d7ri">{resultsDisclaimer}</p>

        <div className="mt-8 grid gap-5 lg:grid-cols-3" data-id="element-249" data-mp="22210cxffb53o">
          {homepageWins.map(result => <article key={result.id} className="case-card flex h-full flex-col border border-line border-t-4 border-t-crimson bg-white p-6 md:p-8" data-id="element-250" data-mp="26z12ix95jnpi">
              <p className="text-[40px] font-extrabold leading-[1.1] tracking-tight text-ink sm:text-[48px]" data-id="element-251" data-mp="19ahd92fph6we">
                {result.figure}
              </p>
              <p className="mt-2 text-label font-bold text-crimson" data-id="element-252" data-mp="1j8x2t0z3483s">{result.outcome}</p>
              <h3 className="mt-6 text-h3 font-bold text-ink" data-id="element-253" data-mp="1o29n4ywqdsqq">{result.title}</h3>
              <p className="mt-3 text-body-m text-slate md:text-body" data-id="element-254" data-mp="qmm3dtn7sd8k">{result.summary}</p>
              <SiteLink path={result.storyPath || `/cases/#${result.id}`} className="mt-auto inline-flex min-h-[48px] items-center gap-2 pt-6 text-label font-bold text-ink underline underline-offset-4" data-id="element-255" data-mp="vkdtqj87nran">
                {result.storyLabel || "View the published summary"}
                <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-256" data-mp="x8zh3rv4rw0j" />
              </SiteLink>
            </article>)}
        </div>
      </div>
    </section>;
}